import { ElementRef, } from "@angular/core";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
var ContactPanelComponent = /** @class */ (function () {
    function ContactPanelComponent(hostRef) {
        this.hostRef = hostRef;
        this.loadMedia = false;
        this.scrollPosition = null;
    }
    Object.defineProperty(ContactPanelComponent.prototype, "hostClasses", {
        get: function () {
            return resolveThemeCssClass(this.data.panelSettings);
        },
        enumerable: true,
        configurable: true
    });
    ContactPanelComponent.prototype.onWindowScroll = function () {
        this.scrollPosition = window.pageYOffset;
        if (this.scrollPosition + window.outerHeight >
            this.panelEl.nativeElement.offsetTop) {
            this.loadMedia = true;
        }
    };
    ContactPanelComponent.prototype.ngAfterViewInit = function () {
        this.scrollPosition = window.pageYOffset;
        if (this.scrollPosition + window.outerHeight >
            this.panelEl.nativeElement.offsetTop) {
            this.loadMedia = true;
        }
        this.setCustomThemeProperties(this.data);
    };
    ContactPanelComponent.prototype.setCustomThemeProperties = function (d) {
        if (d.capitalizeTitle && d.capitalizeTitle.value) {
            this.titleEl.nativeElement.style.textTransform = "uppercase";
        }
        applyTitleSettings(d, this.titleEl);
    };
    return ContactPanelComponent;
}());
export { ContactPanelComponent };
